<template>
	<div class="grid gap-4">
		<FormKit type="text" name="company" label="Maatschappij" />
		<FormKit type="loanlinkCurrency" name="creditLimit" label="KredietLimiet" />
		<FormKit
			type="loanlinkCurrency"
			name="currentBalance"
			label="Actuele Saldo"
		/>
		<FormKit type="loanlinkCurrency" name="monthlyAmount" label="Maandbedrag" />
		<FormKit type="loanlinkDate" name="endDate" label="Einddatum" />
		<FormKit
			type="loanlinkOption"
			name="settledForNewMortgage"
			label="Afgelost voor nieuwe hypotheek"
			:options="{ true: 'Ja', false: 'Nee' }"
		/>
	</div>
</template>
